<script>
	// Imports
	import { formatDate } from "../../helpers/"
	import { Landing as Page, Webnav } from "../../components/";
	import { getContext, onMount } from "svelte";


	// State
	const { client, session} = getContext("services")
	// let firstname = session.getSession().user.name.split(' ')[0] || '🌄'
	let records = []
	
	// Fetch 
	const fetchRecords = () => { 
	
	}

</script>

<style>
section[slot="header"]{
	font-size: 2em;
	font-weight:600;
	padding-top:1em;
}

section[slot="mobnav"]{
	height:100%;
}

section[slot="webnav"]{
	width: 100%;
}
</style>

<Page>

	<section slot="webnav">
		<Webnav></Webnav>
	</section>
	
	<section slot="main" >
		Privacy Policy
  	</section>

</Page>


